import ContinuePage from "@components/ContinuePage"
import { isHomeDesignFlow } from "@helpers/localStorage"

export default function UnleashLookPage() {
  if (isHomeDesignFlow()) {
    return <ContinuePage emoji="🏠" translationKey="unleashLookHomeDesign" />
  }
  return <ContinuePage emoji="✨" translationKey="unleashLook" />
}
